import {i18n} from "src/boot/i18n";
import {AbstractPlayableContent} from "../../../playable/models/AbstractPlayableContent";
import {defaultVersion} from "../../../playable/models/Version";

// TODO: Might simplify this using 'NONE' | 'PLAYABLE_CONTENT'
export type LoopType = 'NONE' | 'PLAY' | 'PART' | 'SECTION' | 'RHYTHMIC_BLOC' | 'LIST'

// TODO (v2): Add Support for RhythmicBloc
export const LOOP_TYPES_DISPLAY_VALUES = {
  'NONE': i18n.t('loopParameters.types.none') as string,
  'PLAY': i18n.t('loopParameters.types.play') as string,
  'PART': i18n.t('loopParameters.types.part') as string,
  'SECTION': i18n.t('loopParameters.types.section') as string,
  'RHYTHMIC_BLOC': i18n.t('loopParameters.types.rhythmicBloc') as string,
  'LIST': i18n.t('loopParameters.types.list') as string
}

export class LoopParameters {
  readonly type: LoopType;
  readonly playableContent: AbstractPlayableContent

  get isActive() {
    return this.type !== 'NONE';
  }

  constructor(mode: LoopType, playableContent: AbstractPlayableContent) {
    this.type = mode;
    this.playableContent = playableContent;
  }
}
export const defaultLoopParameters = new LoopParameters('NONE', defaultVersion);
